/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-28 11:35:31
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-09-30 14:51:37
 * @FilePath: \pit-bimwin-react-ui\src\hooks\useMenuState.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useState } from 'react';
interface MenuState {
  mainPerspective?: boolean; // 主视角
  currentMainPerspective?: boolean; // 设置当前为主视图
  resetMainPerspective?: boolean; // 重置主视图
  directoryTree: boolean; // 目录树
  fullScreen?: boolean; // 全屏
  measurement: boolean; // 测量
  section: boolean; // 剖切
  axialSection: boolean; // 轴向剖切
  roamingMode?: boolean; // 漫游模式
  componentDetails: boolean; // 构件详情
  layer?: boolean; // 图层
  annotation?: boolean; // 批注
  label: boolean; // 标签
  setUp: boolean; // 设置
  minimap?: boolean; // 小地图
  basicInformation: boolean; // 基本信息
}
const menuStateInit: MenuState = {
  mainPerspective: false, // 主视角
  currentMainPerspective: false, // 设置当前为主视图
  resetMainPerspective: false, // 重置主视图
  directoryTree: false, // 目录树
  fullScreen: false, // 全屏
  measurement: false, // 测量
  section: false, // 剖切
  axialSection: false, // 轴向剖切
  roamingMode: false, // 漫游模式
  componentDetails: false, // 构件详情
  layer: false, // 图层
  annotation: false, // 批注
  label: false, // 标签
  setUp: false, // 设置
  minimap: false, // 小地图
  basicInformation: false, // 基本信息
};
export const useMenuState = () => {
  const [menuState, setMenusState] = useState<MenuState>(menuStateInit);
  const setMenuState = (params: Record<string, boolean>) => {
    setMenusState(pre => {
      return { ...pre, ...params };
    });
  };
  return {
    menuState,
    setMenuState,
  };
};
